import Link from 'next/link';
import { FC } from 'react';
import {
  NavBarActiveKey,
  NavBarBadge,
  NavMenuItemType,
} from 'src/app.core/linkareer/constant/navBarMenuItems';
import styled from 'styled-components';

interface IFSecondDepthNavBarProps {
  className?: string;
  activeKey: NavBarActiveKey;
  menuItems: NavMenuItemType[];
}

const SecondDepthNavBar: FC<IFSecondDepthNavBarProps> = ({ className, activeKey, menuItems }) => {
  return (
    <StyledWrapper className={className}>
      <ul className="nav-menu-list">
        {menuItems.map((menuItem) => (
          <li
            key={`nav-secon-depth-list-${menuItem.label}`}
            className={`nav-menu-item ${menuItem.badge === NavBarBadge.NEW ? 'new-badge' : ''}`}
            data-active={activeKey === menuItem.active ? 'active' : ''}
          >
            <Link href={menuItem.href}>{menuItem.label}</Link>
          </li>
        ))}
      </ul>
    </StyledWrapper>
  );
};

export default SecondDepthNavBar;

const StyledWrapper = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 60px;
  left: 0;
  background-color: #ffffff;
  box-shadow: rgba(170, 170, 170, 0.16) 0px 6px 9px -7px inset;

  .nav-menu-list {
    width: 1100px;
    height: 60px;
    display: flex;
    align-items: center;
    gap: 28px;
    border-bottom: 1px solid #eeeeee;
    margin: 0 auto;

    .nav-menu-item {
      height: 100%;
      line-height: 59px;
      position: relative;
      padding: 0;
      box-sizing: border-box;

      &.new-badge::after {
        content: '';
        width: 6px;
        height: 6px;
        background-color: #ef2929;
        box-sizing: border-box;
        border-radius: 6px;
        position: absolute;
        top: 18px;
        right: -8px;
      }

      & > a {
        font-size: 16px;
        font-weight: 500;
        line-height: 60px;
        letter-spacing: -0.64px;
        text-align: left;
        color: #666666;
        display: block;
        position: relative;
        text-decoration: none;
      }

      &[data-active='active'] {
        border-bottom: 2.5px solid #01a0ff;

        & > a {
          color: #01a0ff;
          font-weight: bold;
        }
      }

      &:hover {
        & > a {
          color: #01a0ff;
          font-weight: bold;
        }
      }
    }
  }
`;
